/* ==========================================================================
   Collection Filters & Sort — vanilla JS
   ========================================================================== */

(function () {
  'use strict';

  var filterDrawer = document.querySelector('[data-filter-drawer]');

  /* --------------------------------------------------------------------------
     1. FILTER DRAWER (mobile)
     -------------------------------------------------------------------------- */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (filterDrawer) {
        filterDrawer.classList.add('is-open');
        window.Midastime.openOverlay();
      }
    });
  });

  document.querySelectorAll('[data-filter-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (filterDrawer) {
        filterDrawer.classList.remove('is-open');
        window.Midastime.closeOverlay();
      }
    });
  });

  window.Midastime.on('overlay:click', function () {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
  });

  window.Midastime.on('escape:pressed', function () {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
  });

  /* --------------------------------------------------------------------------
     2. FILTER GROUP TOGGLE (accordion)
     -------------------------------------------------------------------------- */
  document.querySelectorAll('[data-filter-group-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group = toggle.closest('.collection-filters__group');
      if (group) group.classList.toggle('is-open');
    });
  });

  /* --------------------------------------------------------------------------
     3. SORT SELECT
     -------------------------------------------------------------------------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* --------------------------------------------------------------------------
     4. FILTER CHECKBOXES — build URL and navigate
     -------------------------------------------------------------------------- */
  function applyFilters() {
    var url = new URL(window.location.href);

    // Clear existing filter params (keep sort_by)
    var sortBy = url.searchParams.get('sort_by');
    var params = new URLSearchParams();
    if (sortBy) params.set('sort_by', sortBy);

    // Collect all checked checkboxes
    var checkboxes = document.querySelectorAll('[data-filter-checkbox]:checked');
    checkboxes.forEach(function (cb) {
      params.append(cb.name, cb.value);
    });

    // Collect price range
    var priceMin = document.querySelector('[data-filters-sidebar] [data-price-min]');
    var priceMax = document.querySelector('[data-filters-sidebar] [data-price-max]');
    if (priceMin && priceMin.value) params.set(priceMin.name, priceMin.value + '00');
    if (priceMax && priceMax.value) params.set(priceMax.name, priceMax.value + '00');

    url.search = params.toString();
    window.location.href = url.toString();
  }

  // Desktop: auto-apply on checkbox change
  document.querySelectorAll('[data-filters-sidebar] [data-filter-checkbox]').forEach(function (cb) {
    cb.addEventListener('change', applyFilters);
  });

  // Desktop: price range — apply on Enter
  document.querySelectorAll('[data-filters-sidebar] [data-price-min], [data-filters-sidebar] [data-price-max]').forEach(function (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyFilters();
    });
  });

  // Mobile: apply button
  document.querySelectorAll('[data-filter-apply]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Sync mobile checkboxes to the URL
      var url = new URL(window.location.href);
      var sortBy = url.searchParams.get('sort_by');
      var params = new URLSearchParams();
      if (sortBy) params.set('sort_by', sortBy);

      var drawerCheckboxes = filterDrawer.querySelectorAll('[data-filter-checkbox]:checked');
      drawerCheckboxes.forEach(function (cb) {
        params.append(cb.name, cb.value);
      });

      var priceMin = filterDrawer.querySelector('[data-price-min]');
      var priceMax = filterDrawer.querySelector('[data-price-max]');
      if (priceMin && priceMin.value) params.set(priceMin.name, priceMin.value + '00');
      if (priceMax && priceMax.value) params.set(priceMax.name, priceMax.value + '00');

      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

})();
